import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import { Box, Typography, Grid, Button } from "@mui/material";
import SummaryIcon1 from "../../../static/img/icons/png/summary-icon-1.png";
import SummaryElipse from "../../../static/img/summary-elipse.png";
import { InfoCircle, Edit, User } from "iconsax-react";
import TableComponent from "../../../components/global/Table";
import FooterComponent from "../../../components/global/Footer";
import dayjs from 'dayjs';
const { URL_PREFIX } = window;
class VF1Step4 extends React.Component {
  constructor() {
    super();
    this.state = {};
    this.calcDays = this.calcDays.bind(this);
    this.getRoom = this.getRoom.bind(this);
  }

  componentWillMount() { }

  calcDays(startDate, endDate) {
    const day = moment(startDate);
    let businessDays = 0;
    while (day.isSameOrBefore(endDate, "day")) {
      if (day.day() !== 0 && day.day() !== 6) {
        businessDays++;
      }
      day.add(1, "d");
    }
    return businessDays;
  }

  getRoom(id) {
    const rooms = this.props.vf1.soDetail.roomAllocation;
    let room = {};
    if (Array.isArray(rooms)) {
      const selectedRoom = rooms.filter((x) => x.Id === id);
      room = selectedRoom[0];
    }
    let totalDays = 0;
    if (room.Room_Nights__c) {
      totalDays = room.Room_Nights__c;
    }
    return totalDays;
  }

  render() {
    const { soDetail } = this.props.vf1;

    const column = [
      { label: "#", value: "no" },
      { label: "Name", value: "name", type: "textWithIcon" },
      { label: "Room Assigned", value: "roomType", type: "badge" },
      // { label: "Room Type", value: "roomType", type: "badge" },
      { label: "Sharing Type", value: "sharingType" },
      { label: "Date", value: "date" },
    ];

    const data = soDetail.segments.map((room, index) => {
      const getRoomName = soDetail.roomAllocation.find((x) => {
        return x.Id === room.Room_Allocation__c;
      });

      return {
        no: index + 1,
        name:
          room?.Guest_ID__r?.Guest_FullName__r === null
            ? "-"
            : `${room?.Guest_ID__r?.Guest_FullName__r?.Name} `,
        roomAllocation: getRoomName?.Name,
        roomAssigned: room?.Name,
        roomType: room?.RoomType__c,
        sharingType: room?.Sharing_Type__c,
        date: `${dayjs(room?.Start_Date__c).format('DD/MMM/YYYY')} - ${dayjs(room?.End_Date__c).format('DD/MMM/YYYY')}`,
      };
    });

    return (
      <>
        <div style={{ margin: "30px" }}>
          <Box sx={{ width: "auto" }}>
            <Typography variant="h4" sx={{ fontWeight: 600, fontSize: "30px" }}>
              Summary
            </Typography>
          </Box>
          <Box sx={{ width: "auto", marginTop: "10px" }}>
            <Typography
              variant="text-large"
              sx={{
                color: "#667085",
                fontSize: "2rem",
                fontWeight: 300,
              }}>
              Sales order details
            </Typography>
          </Box>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Box
              sx={{
                marginTop: "20px",
                padding: "32px 48px 48px",
                border: "1px solid #EAECF0",
                boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.06)",
                borderRadius: "8px",
                width: "100%",
                height: "100%",
                backgroundColor: "#F9FAFB",
                backgroundImage: `url(${SummaryElipse})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right",
              }}>
              <img src={SummaryIcon1} />
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "24px",
                  color: "#101828",
                  marginTop: "15px",
                }}>
                Thank you for completing your sales order!
              </Typography>
              <Typography
                sx={{
                  fontWeight: 300,
                  fontSize: "16px",
                  color: "#475467",
                  marginTop: "10px",
                }}>
                We will send an email to each one of the guests for the
                essential <br /> informations, please inform them to check their
                emails
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "20px",
                }}>
                <Button
                  sx={{
                    padding: "12px 20px",
                    height: "48px",
                    border: "1px solid #D0D5DD",
                    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    borderRadius: "8px",
                    color: "#344054",
                  }}>
                  <InfoCircle style={{ marginRight: "10px" }} />
                  <Typography sx={{ fontWeight: 800, fontSize: "13px" }}>
                    Need help?
                  </Typography>
                </Button>
                <a
                  href={`${URL_PREFIX}/vf1/wizard`}
                  style={{ textDecoration: "none" }}>
                  <Button
                    sx={{
                      padding: "12px 20px",
                      height: "48px",
                      border: "1px solid #D0D5DD",
                      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                      borderRadius: "8px",
                      color: "white",
                      background: "#2F37B5",
                      marginLeft: "20px",
                      ":hover": {
                        border: "1px solid #D0D5DD",
                        color: "white",
                        background: "#2F37B5",
                      },
                    }}>
                    <Edit style={{ marginRight: "10px" }} />

                    <Typography
                      sx={{
                        fontWeight: 800,
                        fontSize: "13px",
                        color: "#FFFFFF",
                      }}>
                      Edit
                    </Typography>
                  </Button>
                </a>
              </Box>
            </Box>
          </div>
          <div>
            <Box
              sx={{
                marginTop: "40px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                border: "1px solid #EAECF0",
                padding: "24px",
                boxShadow:
                  " 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
                borderRadius: "8px",
              }}>
              <Grid container>
                <Grid item md={2.4} sm={4}>
                  <Typography
                    sx={{
                      color: "#101828",
                      fontWeight: 600,
                      fontSize: "16px",
                    }}>
                    Sales Order Details
                  </Typography>
                  <Typography
                    sx={{
                      color: "#101828",
                      fontWeight: 600,
                      fontSize: "16px",
                    }}>
                    Sales Person Name
                  </Typography>
                  <Typography
                    sx={{
                      color: "#101828",
                      fontWeight: 600,
                      fontSize: "16px",
                    }}>
                    Contact Name
                  </Typography>
                </Grid>
                <Grid item md={2.4} sm={4}>
                  <Typography
                    sx={{
                      color: "#344054",
                      fontWeight: 300,
                      fontSize: "16px",
                    }}>
                    {soDetail.Name || ""}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#344054",
                      fontWeight: 300,
                      fontSize: "16px",
                    }}>
                    {soDetail.Account_Name__r.Name || ""}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#344054",
                      fontWeight: 300,
                      fontSize: "16px",
                    }}>
                    {soDetail.Contact_Name__r.Name || ""}
                  </Typography>
                </Grid>

                {/*TODO: custom vertical rule */}

                <Grid item md={2.4} sm={4}>
                  <div />
                </Grid>

                <Grid item md={2.4} sm={4}>
                  <Typography
                    sx={{
                      color: "#101828",
                      fontWeight: 600,
                      fontSize: "16px",
                    }}>
                    Number of Guests
                  </Typography>
                  <Typography
                    sx={{
                      color: "#101828",
                      fontWeight: 600,
                      fontSize: "16px",
                    }}>
                    Order Date
                  </Typography>
                </Grid>
                <Grid item md={2.4} sm={4}>
                  <Typography
                    sx={{
                      color: "#344054",
                      fontWeight: 300,
                      fontSize: "16px",
                    }}>
                    {soDetail.Num_of_Guests__c || ""}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#344054",
                      fontWeight: 300,
                      fontSize: "16px",
                    }}>
                    {moment(soDetail.SO_Date__c).format("DD/MMM/YYYY")}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </div>

          {/* Guest Allocation Table */}
          <TableComponent
            column={column}
            data={data}
            label="Guest Allocation"
            totalGuest={data.length}
          />

          <FooterComponent />
        </div>
      </>
    );
  }
}

VF1Step4.propTypes = {
  vf1: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const mapStateToProps = (state) => ({
  vf1: state.vf1,
});

export default connect(mapStateToProps, mapDispatchToProps)(VF1Step4);
